export class cumulTranches {
	public date: Date;
	public nbOfCommandes: Array<number>;
	public config_cumul: number;//nb de fois qu'une config particulière peut être utilisée à cette date
}